<template>
	<div>
		<div>
			<div style="float: left; margin-right: 10px">
				<qrcode-vue :value="link" :size="size" level="H"></qrcode-vue>
			</div>
			Documento assinado eletronicamente por {{ nome }}, em {{ data }} horário de oficial de Brasília seguindo as normas da Casa
			Militar do Governador da Bahia. A autenticidade deste documento pode ser conferida no site {{ link }}, informando o código
			verificador {{ codigo }}.<br />
			<img src="../../../assets/img/assinatura_eletronica.png" class="logo" style="height: 35px; margin-top: 13px" />
		</div>
	</div>
</template>
<script>
export default {
	props: {
		nome: {
			required: false
		},

		link: {
			required: false
		},

		data: {
			required: false
		},

		funcao: {
			required: false
		},

		codigo: {
			required: false
		}
	},

	data() {
		return {
			size: 95
		}
	}
}
</script>
